import { EnvConfig } from '../../envConfig';

/**
 * The public web URL a share token is reachable at, e.g.
 * `https://www.gripp.it/share/<token>` in production or
 * `https://nonprod.gripp.it/share/<token>` in nonprod.
 *
 * Mirrors `createTagUrl`'s environment-aware subdomain logic. Native needs it
 * to hand a share link it cannot render itself back to the web app; web
 * builds the same URL from `window.location.origin`.
 */
export const createShareUrl = (token: string): string => {
  const subDomain = EnvConfig.prefix === 'prod' ? 'www' : EnvConfig.prefix;

  return `https://${subDomain}.gripp.it/share/${token}`;
};
